import { Component, OnInit, Input } from '@angular/core';
import { FormEditorBase } from './../../../../../models/forms/formEditor.base';
import { Switch } from './../../../../../models/editors/switch.model';

@Component({
  selector: 'swb-switch',
  templateUrl: './switch.component.html'
})
export class SwitchComponent extends FormEditorBase implements OnInit {

  ngOnInit() {
  }

  public isSwitchOn(): boolean {
    return this.control.value;
  }

  public getSwitchLabel(): string {
    if (this.control.value) {
      return this.field.label;
    }
    return (<Switch>this.field).labelFalse;
  }

}
